import request from '@/utils/request'
const route_swiveltable = '/application/swiveltable'
const route_gears = '/application/gears'
const route_servicelife = '/application/servicelife'
const route_synchronousbelt = '/application/synchronousbelt'
const route_conveyorbelt = '/application/conveyorbelt' //传送带
const route_elevator = '/application/elevator' //升降机
const route_gearsandracks = '/application/gearsandracks' //齿轮齿条
const route_screwdrive = '/application/screwdrive' //丝杆传动
const route_agvcar = '/application/agvcar' //AGV
// 齿轮齿条
export function transRack(data) {
  return request.post(route_gearsandracks,JSON.stringify(data),{
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 丝杆传动
export function transScrew(data) {
  return request.post(route_screwdrive,JSON.stringify(data),{
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// AGV
export function transAGV(data) {
  return request.post(route_agvcar,JSON.stringify(data),{
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 转台
export function transTurnTable(data) {
  return request.post(route_swiveltable,JSON.stringify(data),{
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 齿轮
export function transGearRotation(data) {
  return request.post(route_gears,JSON.stringify(data),{
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 同步带
export function transTimingBelt(data) {
  return request.post(route_synchronousbelt,JSON.stringify(data),{
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 传送带
export function transConveyorBelt(data) {
  return request.post(route_conveyorbelt,JSON.stringify(data),{
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 升降机
export function transLifter(data) {
  return request.post(route_elevator,JSON.stringify(data),{
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 下发负载参数 得到可用减速机列表
export function getServicelife(data) {
  var lang = localStorage.getItem('lang');
  data.lang = lang;
  return request.post(route_servicelife,JSON.stringify(data),{
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}



// WEBPACK FOOTER //
// ./src/store/electric_app.js